/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */

import React from "react";
import { Flex, Progress, Text } from "@mantine/core";

const PercentCell: React.FC<any> = React.memo(
  ({
    column, dispatch, rowKeyValue, ...props
  }) => {
    const value = props.rowData[`${column.key}`];
    return (
      <Flex align="center" gap={5}>
        <Progress className="flex-1" value={parseInt(value, 10)} color="main.4" radius="xl" />
        <Text className="w-[20px]" c="text.4" fw={600} size="xs">
          {Math.round(value)}
          %
        </Text>
      </Flex>
    );
  },
);

export default PercentCell;
